import React from 'react';
import { Card, CardHeader, CardHeaderBtn, CardBody, CardFooter } from './../../components/card/card.jsx';
import { Icon } from '@iconify/react';

function PagesOrderDetails() {
	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<ol className="breadcrumb">
						<li className="breadcrumb-item"><a href="#/">PAGES</a></li>
						<li className="breadcrumb-item active">ORDER DETAILS</li>
					</ol>
					<h1 className="page-header mb-0">Order Details</h1>
				</div>
			</div>
			
			<div className="mb-md-3 mb-2 d-flex flex-wrap">
				<div className="me-4 mb-md-0 mb-2 pe-2"><a href="#/" className="text-decoration-none text-body d-flex align-items-center"><Icon icon="material-symbols-light:print-outline-sharp" className="fs-20px opacity-5 me-2 my-n2" /> Print</a></div>
				<div className="me-4 mb-md-0 mb-2 pe-2"><a href="#/" className="text-decoration-none text-body d-flex align-items-center"><Icon icon="material-symbols-light:settings-backup-restore" className="fs-20px opacity-5 me-2 my-n2" /> Restock items</a></div>
				<div className="me-4 mb-md-0 mb-2 pe-2"><a href="#/" className="text-decoration-none text-body d-flex align-items-center"><Icon icon="material-symbols-light:edit-document-outline-sharp" className="fs-20px opacity-5 me-2 my-n2" /> Edit</a></div>
				<div className="me-4 mb-md-0 mb-2 pe-2 dropdown-toggle">
					<a href="#/" data-bs-toggle="dropdown" className="text-decoration-none text-body d-inline-flex align-items-center">More Actions</a>
					<div className="dropdown-menu">
						<a className="dropdown-item" href="#/">Action</a>
						<a className="dropdown-item" href="#/">Another action</a>
						<a className="dropdown-item" href="#/">Something else here</a>
						<div role="separator" className="dropdown-divider"></div>
						<a className="dropdown-item" href="#/">Separated link</a>
					</div>
				</div>
			</div>
			<div className="row gx-3">
				<div className="col-xl-8">
					<Card className="mb-3">
						<CardHeader className="with-btn">
							PRODUCTS (3)
							<CardHeaderBtn />
						</CardHeader>
						<CardBody>
							<div className="row align-items-center">
								<div className="col-lg-8 d-flex align-items-center">
									<div className="h-50px w-50px d-flex align-items-center justify-content-center position-relative bg-white p-2">
										<img src="/quantum-react/assets/img/product/product-1.jpg" alt="" className="mw-100 mh-100" />
										<span className="w-16px h-16px p-0 d-flex align-items-center justify-content-center badge bg-theme text-theme-color position-absolute end-0 top-0 fw-semibold fs-11px mt-n2 me-n2">1</span>
									</div>
									<div className="ps-3 flex-1">
										<div><a href="#/" className="text-decoration-none text-body">iPhone 14 Pro Max</a></div>
										<div className="text-body text-opacity-50 small">
											SKU: IP14PROMAX-512
										</div>
									</div>
								</div>
								<div className="col-lg-2 m-0 ps-lg-3">
									$999 x 1
								</div>
								<div className="col-lg-2 m-0 text-end">
									$999
								</div>
							</div>
							<hr className="my-3" />
							<div className="row align-items-center">
								<div className="col-lg-8 d-flex align-items-center">
									<div className="h-50px w-50px d-flex align-items-center justify-content-center position-relative bg-white p-2">
										<img src="/quantum-react/assets/img/product/product-2.jpg" alt="" className="mw-100 mh-100" />
										<span className="w-16px h-16px p-0 d-flex align-items-center justify-content-center badge bg-theme text-theme-color position-absolute end-0 top-0 fw-semibold fs-11px mt-n2 me-n2">1</span>
									</div>
									<div className="ps-3 flex-1">
										<div className=""><a href="#/" className="text-decoration-none text-body">One Plus 10 Pro</a></div>
										<div className="text-body text-opacity-50 small">
											SKU: ONEPLUS-10PRO
										</div>
									</div>
								</div>
								<div className="col-lg-2 m-0 ps-lg-3">
									$1,999 x 1
								</div>
								<div className="col-lg-2 m-0 text-end">
									$1,999
								</div>
							</div>
							<hr className="my-3" />
							<div className="row align-items-center">
								<div className="col-lg-8 d-flex align-items-center">
									<div className="h-50px w-50px d-flex align-items-center justify-content-center position-relative bg-white p-2">
										<img src="/quantum-react/assets/img/product/product-3.jpg" alt="" className="mw-100 mh-100" />
										<span className="w-16px h-16px p-0 d-flex align-items-center justify-content-center badge bg-theme text-theme-color position-absolute end-0 top-0 fw-semibold fs-11px mt-n2 me-n2">1</span>
									</div>
									<div className="ps-3 flex-1">
										<div className=""><a href="#/" className="text-decoration-none text-body">Galaxy s23 Ultra</a></div>
										<div className="text-body text-opacity-50 small">
											SKU: SAMSUNG-GALAXYS23
										</div>
									</div>
								</div>
								<div className="col-lg-2 m-0 ps-lg-3">
									$599 x 1
								</div>
								<div className="col-lg-2 text-body m-0 text-end">
									$599
								</div>
							</div>
						</CardBody>
						<CardFooter className="bg-none d-flex px-0">
							<a href="#/" className="btn btn-secondary ms-auto dropdown-toggle me-2">More </a>
							<a href="#/" className="btn btn-theme d-flex align-items-center"><Icon icon="material-symbols-light:add" className="fs-20px me-1 ms-n2 my-n2 d-inline-flex" /> Add Tracking</a>
						</CardFooter>
					</Card>
					<Card>
						<CardHeader className="with-btn">
							PAYMENT RECORDS
							<div className="card-header-btn">
								<a href="#/" className="text-decoration-none">VIEW RECORDS</a>
							</div>
						</CardHeader>
						<CardBody>
							<table className="table table-borderless table-sm m-0">
								<tbody>
									<tr>
										<td className="w-150px">Subtotal</td>
										<td>3 items</td>
										<td className="text-end">$3,496.00</td>
									</tr>
									<tr>
										<td>Tax</td>
										<td>GST 5%</td>
										<td className="text-end">$174.80</td>
									</tr>
									<tr>
										<td>Shipping Fee</td>
										<td>promo code: <u className="text-success fw-bold small">FREESHIPPING</u> <small>(<span className="text-decoration-line-through">$120.00</span>)</small></td>
										<td className="text-end">$0.00</td>
									</tr>
									<tr>
										<td className="pb-2" colSpan="2"><b>Total</b></td>
										<td className="text-end pb-2 text-decoration-underline"><b>$3670.80</b></td>
									</tr>
									<tr>
										<td colSpan="3">
											<hr className="m-0" />
										</td>
									</tr>
									<tr>
										<td className="pt-2 pb-2 text-nowrap">
											Paid by customer
										</td>
										<td className="pt-2 pb-2">
											via <a href="#/" className="text-decoration-none">Paypal</a> (#IRU9589320)
										</td>
										<td className="pt-2 pb-2 text-end">$3670.80</td>
									</tr>
								</tbody>
							</table>
						</CardBody>
						<CardFooter className="bg-none d-flex px-0">
							<a href="#/" className="btn btn-theme ms-auto d-flex align-items-center"><Icon icon="material-symbols-light:check" className="fs-20px me-1 ms-n2 my-n2 d-inline-flex" /> Mark as paid</a>
						</CardFooter>
					</Card>
				</div>
				<div className="col-xl-4">
					<Card className="mb-3">
						<CardHeader className="with-btn">
							NOTES
							<div className="card-header-btn">
								<a href="#/" className="text-decoration-none">EDIT</a>
							</div>
						</CardHeader>
						<CardBody>
							No notes from customer
						</CardBody>
					</Card>
					<Card className="mb-3">
						<CardHeader className="with-btn">
							CUSTOMER
							<div className="card-header-btn">
								<a href="#/" className="text-decoration-none">EDIT</a>
							</div>
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center">
								<a href="#/" className="d-block"><img src="/quantum-react/assets/img/user/user-1.jpg" alt="" width="45" /></a>
								<div className="flex-fill ps-2">
									<a href="#/" className="d-block text-decoration-none text-body fw-semibold">John Smith</a>
									<span className="fs-13px text-body text-opacity-50">johnsmith@gmail.com</span>
								</div>
							</div>
						</CardBody>
					</Card>
					<Card className="mb-3">
						<CardHeader className="with-btn">
							SHIPPING INFORMATION
							<div className="card-header-btn">
								<a href="#/" className="text-decoration-none">EDIT</a>
							</div>
						</CardHeader>
						<CardBody>
							<i className="fa fa-phone"></i> +916-663-4289<br /><br />
							867 Highland View Drive<br />
							Newcastle, CA<br />
							California<br />
							95658<br />
							<br />
							<a href="#/" className="text-decoration-none"><i className="fa fa-map fa-fw"></i> View map</a>
						</CardBody>
					</Card>
					<Card className="mb-3">
						<CardHeader className="with-btn">
							BILLING INFORMATION
							<div className="card-header-btn">
								<a href="#/" className="text-decoration-none">EDIT</a>
							</div>
						</CardHeader>
						<CardBody>
							867 Highland View Drive<br />
							Newcastle, CA<br />
							California<br />
							95658<br />
						</CardBody>
					</Card>
				</div>
			</div>
		</div>
	)
}

export default PagesOrderDetails;